export default "__VITE_ASSET__DZ2rKZpy__"